import { LogoLarge } from '../svgs/LogoLarge';
import { LogoSub } from '../svgs/LogoSub';
import { LogoSmall } from '../svgs/LogoSmall';
import styles from './logo.scss';

interface IProps {
  className?: string;
  small?: boolean;
  sub?: boolean;
}

const Logo = ({ className, small, sub }: IProps) => {
  if (small) {
    return (
      <LogoSmall className={classnames(styles.logo, styles.small, className)} />
    );
  }
  const LogoComponent = sub ? LogoSub : LogoLarge;
  return (
    <LogoComponent
      className={classnames(
        styles.logo,
        sub && styles.sub,
        styles.large,
        className,
      )}
    />
  );
};

export default Logo;
